import React from "react";
import { Link } from "react-router-dom";
import Banner from "../../Constant/Banner/Banner";

const AboutUs = () => {
  const data = [{}];
  return (
    <>
      <Banner imagePath="aboutUsBanner.png" BannerText="About Us" />
      <div className="container w-80">
        <h2 className="text-primary">About Organisation</h2>
        <p className="text-lg py-4">
          Omnia Steels Private Limited (formerly Gupta Steels) is a leading
          business since 40+ years operating across multiple states of India.
          Our ISO & CE certified products are renowned for their superior
          quality and competitive pricing. We provide logistical support to
          supply at any location in India.
          <br />
          <br />
          We are a reliable partner in multiple projects thoughout India. We
          help you build projects that last for generations to come. We are
          recognized with various accolades and appreciation letters from all
          our clients and partners.
          <br />
          <br />
          Our strategic presence enables our team for catering projects
          throughout the nation, from Kashmir to Kanyakumari and from Dwarka to
          Kohima. In fact, we 'Deliver more than just Steel' as our customers
          get unmatched services and timely delivery.
        </p>
      </div>

      <div className="container w-80">
        <h2 className="text-primary">Mission</h2>
        <p className="text-lg py-4">
          <span className="text-bold">"Crafting steel, building trust."</span>is
          the foundation of Omnia Steels’ philosophy.
          <br />
          <br />
          At <span className="text-bold">Omnia Steels Pvt Ltd</span>, we don’t
          just manufacture steel — we engineer confidence. Every wire, rod, and
          product we deliver is crafted with precision, care, and an unwavering
          focus on quality. But beyond the physical strength of our steel lies
          something even stronger:{" "}
          <span className="text-bold">
            the trust of our customers, suppliers, and partners.
          </span>
          <br />
          <br />
          With strong network in Chhattisgarh, Telangana and Andhra Pradesh. Our
          ISO & CE certified products are renowned for their superior quality
          and competitive pricing. We have a top management experienced since
          the past 4 decades in the manufacturing and steel industry.
          <br />
          <br />
          {/* Our strategic presence enables nationwide project catering. 
          <br />
          <br />
          In fact, 
          <br />
          <br /> */}
          We are strongly guided by our core values{" "}
          <span className="text-bold">(NO RUST):</span>
          <ul>
            <li>
              <span className="text-bold">N</span>ovel innovations
            </li>
            <li>
              <span className="text-bold">O</span>n-time delivery
            </li>
            <li>
              <span className="text-bold">R</span>eliability
            </li>
            <li>
              <span className="text-bold">U</span>pholding quality
            </li>
            <li>
              <span className="text-bold">S</span>ustainability
            </li>
            <li>
              <span className="text-bold">T</span>rustworthiness.
            </li>
          </ul>
        </p>
      </div>

      <div className="container w-80">
        <h2 className="text-primary">Vision</h2>
        <p className="text-lg py-4">
          <span className="text-bold">
            "To shape a resilient tomorrow through steel and service."
          </span>
          <br />
          <br />
          To be recognized as a{" "}
          <span className="text-bold">
            leading and trusted name in the steel industry,
          </span>{" "}
          known not only for the{" "}
          <span className="text-bold">exceptional quality</span> of our products
          but also for the{" "}
          <span className="text-bold">strength of our relationships.</span> We
          envision a future where Omnia Steels sets new benchmarks in
          innovation, sustainability, and ethical business — becoming the{" "}
          <span className="text-bold">preferred partner</span> for customers
          seeking reliability, integrity, and long-term value in every steel
          solution we offer.
        </p>
      </div>

      {/* END Teams w/ 4 cards w/ image on left & descriptio/social link on right */}
    </>
  );
};

export default AboutUs;
